export const DEVICE_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  READY: 2,
  PRINTING: 3,
}

const DEVICE_STATUS_LABELS = {
  [DEVICE_STATUS.INACTIVE]: 'Không hoạt động',
  [DEVICE_STATUS.ACTIVE]: 'Hoạt động',
  [DEVICE_STATUS.READY]: 'Sẵn sàng',
  [DEVICE_STATUS.PRINTING]: 'Đang in',
}

const DEVICE_STATUS_COLORS = {
  [DEVICE_STATUS.INACTIVE]: 'text-danger',
  [DEVICE_STATUS.ACTIVE]: 'text-success',
  [DEVICE_STATUS.READY]: 'text-info',
  [DEVICE_STATUS.PRINTING]: 'text-warning',
}

export const getDeviceStatusText = (status) => DEVICE_STATUS_LABELS[status] ?? 'Không xác định'

export const getDeviceStatusColor = (status) => DEVICE_STATUS_COLORS[status] ?? 'text-secondary'

export const DEVICE_STATUS_OPTIONS = [
  DEVICE_STATUS.READY,
  DEVICE_STATUS.ACTIVE,
  DEVICE_STATUS.INACTIVE,
].map(status => ({ value: status, label: DEVICE_STATUS_LABELS[status] }))
